import React from 'react';
import PropTypes from 'prop-types';
import SmartLink from '../SmartLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faPodcast } from '@fortawesome/free-solid-svg-icons/faPodcast';
import styles from './footer.module.scss';
import FooterPrintOnly from '../FooterPrintOnly';

const Footer = ({
  rootUrl,
  facebookurl,
  twitterurl,
  youtubeurl,
  linkedinurl,
}) => (
  <div className={styles.footer}>
    <div className={styles.footerTop}>
      <div className="container">
        <div className="row">
          <div className={`${styles.col1} col-xs-6 col-lg-3`}>
            <ul className={styles.navList}>
              <li className={`${styles.navItem} ${styles.navHeading}`}>
                Contact
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/contact`}
                  aria-label="Contact Us"
                  target="_self"
                >
                  Contact Us
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  href="https://www.ecri.org/pages/ReportADeviceProblem.aspx"
                  className={styles.navLink}
                  target="_self"
                >
                  Report a Device Problem
                </SmartLink>
              </li>
            </ul>
          </div>
          <div className={`${styles.col2} col-xs-6 col-lg-3`}>
            <ul className={styles.navList}>
              <li className={`${styles.navItem} ${styles.navHeading}`}>
                About ECRI
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/about/`}
                  aria-label="About"
                  target="_self"
                >
                  About
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href="https://blog.ecri.org"
                  aria-label="Blog"
                  target="_self"
                >
                  Blog
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/careers/`}
                  aria-label="Careers"
                  target="_self"
                >
                  Careers
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/events/`}
                  aria-label="Events"
                  target="_self"
                >
                  Events
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/press/`}
                  aria-label="News"
                  target="_self"
                >
                  News
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/podcasts/`}
                  aria-label="Podcast"
                  target="_self"
                >
                  Podcast
                </SmartLink>
              </li>
            </ul>
          </div>

          <div className={`${styles.col3} col-xs-6 col-lg-3`}>
            <ul className={styles.navList}>
              <li className={`${styles.navItem} ${styles.navHeading}`}>
                Solutions
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/providers`}
                  aria-label="Providers"
                  target="_self"
                >
                  Providers
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/insurers/`}
                  aria-label="Insurers"
                  target="_self"
                >
                  Insurers
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/manufacturers`}
                  aria-label="Manufacturers"
                  target="_self"
                >
                  Manufacturers
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/government`}
                  aria-label="Government"
                  target="_self"
                >
                  Government
                </SmartLink>
              </li>
            </ul>
          </div>
          <div className={`${styles.col4} col-xs-6 col-lg-3`}>
            <ul className={styles.navList}>
              <li className={`${styles.navItem} ${styles.navHeading}`}>
                Library
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/library/general-topics`}
                  aria-label="General Topics"
                  target="_self"
                >
                  General Topics
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/library/clinical-specialties`}
                  aria-label="Clinical Specialties"
                  target="_self"
                >
                  Clinical Specialties
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/library/care-settings`}
                  aria-label="Care Settings"
                  target="_self"
                >
                  Care Settings
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.navLink}
                  href={`${rootUrl}/library/roles`}
                  aria-label="Roles"
                  target="_self"
                >
                  Role
                </SmartLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.footerBottom}>
      <div className="container">
        <div className="row end-lg">
          <div className="col-xs-12 col-lg-8">
            <ul className={`${styles.navList} ${styles.copyList}`}>
              <li
                className={styles.navItem}
                dangerouslySetInnerHTML={{
                  __html: `Copyright &copy; ${new Date().getFullYear()} ECRI`,
                }}
              />
              <li className={styles.navItem}>
                <SmartLink
                  href={`${rootUrl}/terms-of-use/`}
                  className={styles.navLink}
                  aria-label="Terms of Use"
                  target="_self"
                >
                  Terms of Use
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  href={`${rootUrl}/privacy-policy/`}
                  className={styles.navLink}
                  aria-label="Privacy Policy"
                  target="_self"
                >
                  Privacy Policy
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  href={`${rootUrl}/sitemap/`}
                  className={`${styles.navLink}`}
                  aria-label="Sitemap"
                  target="_self"
                >
                  Sitemap
                </SmartLink>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-lg-4">
            <ul className={`${styles.navList} ${styles.socialList}`}>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.socialLink}
                  rel="noopener noreferrer"
                  href={facebookurl}
                  target="_blank"
                  aria-label="Facebook"
                  title="Facebook"
                >
                  <FontAwesomeIcon
                    className={styles.icon}
                    icon={faFacebookF}
                    size="lg"
                  />
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.socialLink}
                  rel="noopener noreferrer"
                  href={twitterurl}
                  target="_blank"
                  aria-label="Twitter"
                  title="Twitter"
                >
                  <FontAwesomeIcon
                    className={styles.icon}
                    icon={faTwitter}
                    size="lg"
                  />
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.socialLink}
                  rel="noopener noreferrer"
                  href={youtubeurl}
                  target="_blank"
                  aria-label="Youtube"
                  title="Youtube"
                >
                  <FontAwesomeIcon
                    className={styles.youTubeIcon}
                    icon={faYoutube}
                    size="lg"
                  />
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.socialLink}
                  rel="noopener noreferrer"
                  href={linkedinurl}
                  target="_blank"
                  aria-label="LinkedIn"
                  title="LinkedIn"
                >
                  <FontAwesomeIcon
                    className={styles.icon}
                    icon={faLinkedinIn}
                    size="lg"
                  />
                </SmartLink>
              </li>
              <li className={styles.navItem}>
                <SmartLink
                  className={styles.socialLink}
                  rel="noopener noreferrer"
                  href={`${process.env.REACT_APP_PUBLIC_URL}/podcasts`}
                  target="_blank"
                  aria-label="Podcast"
                  title="Podcast"
                >
                  <FontAwesomeIcon className={styles.icon} icon={faPodcast} />
                </SmartLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FooterPrintOnly />
  </div>
);

Footer.propTypes = {
  facebookurl: PropTypes.string.isRequired,
  twitterurl: PropTypes.string.isRequired,
  youtubeurl: PropTypes.string.isRequired,
  linkedinurl: PropTypes.string.isRequired,
};

export default Footer;
